<div class="pt-6">
  <div class="p-2 ">
    <h3 [ngClass]="'text-'+globals.colorTheme">
      <i class="material-icons">book</i>
      <span *ngIf="isQuoteUpdate;else other_content">Update {{QuoteButtonName}}</span>
      <ng-template #other_content>Sales</ng-template>
    </h3>
  </div>
  <mat-accordion class="example-headers-align">
    <mat-expansion-panel formcontrolname [expanded]="step === 0" (opened)="setStep(0)" hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Customer


        </mat-panel-title>
        <mat-panel-description>
          <small> {{customerSearchDescription}}
          </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-user-circle fa-2x"></i>
        </span>
      </mat-expansion-panel-header>

      <app-customer-search [forSalesOrder]="false" [selectedEmailType]="pendingAgreementConfig.emailType"
        (sendResponseEventEmitter)="receiveCustomers($event)">
      </app-customer-search>
      <br>
      <app-customer-list [customersDetailList]="customers" (sendResponseEventEmitter)="receiveSelectedCustomer($event)">
      </app-customer-list>
      <div class="text-center full-width">
        <button *ngIf="showBackToTopForCustomers" mat-stroked-button class="magin_5 color_green"
          (click)="backToTop();">Back to the
          top</button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle="true" [expanded]="step === 1" (opened)="setStep(1)" *ngIf="selectedCustomer">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Credit Check
        </mat-panel-title>
        <mat-panel-description>
          <small>Available :
            <span *ngIf="customerLimitType > 0">{{customerLimitType | currency:'USD':'$':'1.2-2'}} </span>
            <span *ngIf="customerLimitType == 0">No Credit Limit</span>
            <span *ngIf="customerLimitType < 0">No Credit</span>
          </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-credit-card fa-2x"></i>
        </span>
      </mat-expansion-panel-header>
      <mat-card appearance="outlined">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Balance</th>
              <th scope="col"> {{credit.balance | currency}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Current</th>
              <td> {{credit.current | currency}}</td>
            </tr>
            <tr>
              <th scope="row">Past Due</th>
              <td> {{credit.pastDue | currency}}</td>
            </tr>
            <tr>
              <th scope="row">Available</th>
              <td>
                <span *ngIf="customerLimitType > 0">{{customerLimitType | currency:'USD':'$':'1.2-2'}} </span>
                <span *ngIf="customerLimitType == 0">No Credit Limit</span>
                <span *ngIf="customerLimitType < 0">No Credit</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Prepay</th>
              <td> {{myMath.abs(credit.prepay) | currency}}</td>
            </tr>
            <tr>
              <th scope="row">Booking</th>
              <td> {{ credit.booking | currency}}</td>
            </tr>
        </table>
      </mat-card>
      <br>
      <div align="center">
        <!--<div id="nextButtonRow"> -->
        <button mat-button
          class="mat-stroked-button-WhiteBackground-GreenText ta-customer-openbooking magin_5 color_green"
          (click)="openBookings();">Open
          Bookings</button>
        &nbsp;<button mat-button
          class="mat-stroked-button-WhiteBackground-GreenText ta-customer-openprepay magin_5 color_green"
          (click)="openPrepays();">Open
          Prepays</button>
        &nbsp;
        <button id="selectFarmAndField" mat-button #selectFarmAndField="matButton"
          [ngClass]="'mat-focus-indicator ta-selectFarmAndField text-white magin_5 btn btn-'+globals.colorTheme"
          (click)="getFarmAndField(); isItemSearchDisable=false" *ngIf="isProUser && !isFromQuote">Splits</button>
        <button id="nextButton" mat-button #btnCreditCheckNext="matButton"
          [ngClass]="'mat-focus-indicator ta-customer-next text-white magin_5 btn btn-'+globals.colorTheme"
          (click)="setStep(3); isItemSearchDisable=false; showFarmAndFields = false">Next</button>

        <!-- <a v-if="emailContent.mailTostring" [href]="emailContent.mailTostring" target="_blank" rel="noopener noreferrer">Email Us</a> -->
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle="true" [expanded]="step === 2" (opened)="setStep(2)"
      *ngIf="isProUser && isfarmAndFields && !isFromQuote">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Farm and Field
        </mat-panel-title>
        <mat-panel-description>
          <small>{{selectedFarmAndField}}
          </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-columns fa-2x"></i>
        </span>
      </mat-expansion-panel-header>
      <span *ngIf="selectedFarmAndField != 'No farm and fields available.'">Below are farms and fields asscoicated to
        your customer please select a farm or field.</span>
      <span *ngIf="selectedFarmAndField == 'No farm and fields available.'">There are no farms and fields asscoicated to
        your customer.</span>
      <br>
      <br>
      <app-farm-field [customer]="selectedCustomer"
        [isDifferentLocationItemSelected]="getIsDifferentLocationItemSelected()"
        (sendResponseEventEmitter)="receiveFarmAndFields($event)"></app-farm-field>
      <br>
      <div align="center">
        <button id="nextButton" mat-button #btnCreditCheckNext="matButton"
          [ngClass]="'mat-focus-indicator ta-customer-next text-white magin_5 btn btn-'+globals.colorTheme"
          (click)="nextStep(); isItemSearchDisable=false;showFarmAndFields = false ">Next</button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel formcontrolname [expanded]="step === 3" (opened)="setStep(3)" [disabled]="isItemSearchDisable"
      hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Item
        </mat-panel-title>
        <mat-panel-description>
          <small> Search Item </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-shopping-basket fa-2x"></i>
        </span>
      </mat-expansion-panel-header>

      <app-item-search [itemSearchType]="ItemSearchType" [forSalesOrder]="false"
        (sendResponseEventEmitter)="receiveItems($event)"></app-item-search>
      <br>
      <app-item-list [forSalesOrder]="false" [itemsDetailList]="itemsDetails"
        [isFarmAndFieldSelected]="showFarmAndFields" (sendResponseEventEmitter)="itemSelection($event)">
      </app-item-list>
      <div class="text-center full-width">
        <button *ngIf="showBackToTopForItems" mat-stroked-button class="magin_5 color_green" (click)="backToTop();">Back
          to the
          top</button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel formcontrolname [expanded]="step === 4" (opened)="setStep(4)" [disabled]="isItemAddDisable"
      *ngIf="showItemDetails" hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Item Details
        </mat-panel-title>
        <mat-panel-description>
          <small> {{itemNameForDetails | slice :0 :50 }}</small>
        </mat-panel-description>
        <span>
          <i class="fas fa-dolly-flatbed fa-2x"></i>
        </span>
      </mat-expansion-panel-header>

      <mat-form-field *ngIf="isProUser">
        <mat-label>Select Location</mat-label>
        <mat-select [disabled]="showFarmAndFields" [(ngModel)]="selectedItem.itemBalance.Location"
          (selectionChange)="onLocationChange()">
          <mat-option *ngFor="let location of selectedItem.selectedItemLocations;" [value]="location.Location">
            {{location.Location}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Quantity</mat-label>
        <input [disabled]="!selectedItem.isAllowedEdit" (keyup.enter)="onEnter()" class="ta-itemdetails-quantity"
          matInput name="quantity" type="tel" onlyNumber="true"
          onKeyPress="if((this.value.length==14 && this.value.indexOf('.') > -1) || this.value.length == 13) return false;"
          placeholder="" [(ngModel)]="selectedItem.itemBalance.OnHandQuantity"
          (input)="checkInput($event); CalculateAmount();" (focus)="onFocus($event);" min="0" (blur)="onBlur($event);"
          data-hj-whitelist>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Selling Unit of Measure</mat-label>
        <input [disabled]="!selectedItem.isAllowedEdit" class="ta-itemdetails-uom" matInput type="string" placeholder=""
          [(ngModel)]="selectedItem.uom" readonly>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Price/Unit</mat-label>
        <input (keyup.enter)="onEnter()" class="ta-itemdetails-priceunit" matInput name="price"
          allowNegativeNumber placeholder="" [(ngModel)]="selectedItem.price"
          [disabled]="selectedItem.IsPriceOveridden ||!selectedItem.isAllowedEdit"
          (input)="checkInput($event); CalculateAmount();">
      </mat-form-field>

      <span class="h7">
        <!-- <input matInput type="number" placeholder="Amount" [(ngModel)]="selectedItem.amount" disabled=true style="font-size:20px;"> -->
        {{selectedItem.amount | currency:'USD':'$':'1.2-2'}}
      </span>

      <mat-form-field class="half-width">
        <mat-label> Start Date</mat-label>
        <input [disabled]="!selectedItem.isAllowedEdit" (keyup.enter)="onEnter()" class="ta-summary-startingdate"
          style="width: 100px;" [min]="selectedItem.minDate" matInput [matDatepicker]="startingDate"
          placeholder="Starting Date" (dateChange)="validateDates()" [(ngModel)]="selectedItem.startDate"
          data-hj-whitelist>
        <mat-datepicker-toggle matSuffix [for]="startingDate"></mat-datepicker-toggle>
        <mat-datepicker #startingDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="half-width">
        <mat-label> End Date </mat-label>
        <input [disabled]="!selectedItem.isAllowedEdit" (keyup.enter)="onEnter()" style="width: 100px;"
          class="ta-summary-endingdate" [min]="selectedItem.startDate" matInput [matDatepicker]="endingdate"
          placeholder="Ending Date" (dateChange)="validateDates()" [(ngModel)]="selectedItem.endDate" data-hj-whitelist>
        <mat-datepicker-toggle matSuffix [for]="endingdate"></mat-datepicker-toggle>
        <mat-datepicker #endingdate></mat-datepicker>
      </mat-form-field>
      <!-- <div id="itemDetailButtonRow"> -->
      <div align="center">
        <button mat-button [disabled]="selectedItem.itemBalance.OnHandQuantity == 0 || selectedItem.amount == 0"
          [ngClass]="'ta-itemdetails-addanother magin_5 text-white btn btn-'+globals.colorTheme"
          (click)="addItem(true,false)">Add Another</button>
        <button mat-button [disabled]="selectedItem.itemBalance.OnHandQuantity == 0 || selectedItem.amount == 0"
          class="btn-info ta-itemdetails-done text-white" (click)="addItem(false,false)">Done</button>
      </div>
    </mat-expansion-panel>
    <div *ngFor="let item of addedItems; let i=index;">
      <input #panelState type="hidden" value="true">
      <mat-expansion-panel hideToggle="true" (opened)="panelState.value=false" (closed)="panelState.value=true">
        <mat-expansion-panel-header class="m-0 pl-2">
          <mat-panel-title class="fg-3 pl-1 m-0">
            <span class="pl-3">
              <small>
                <strong> {{item.name | slice :0 :50}}</strong>
              </small>
            </span>
          </mat-panel-title>
          <mat-panel-description class="pr-5 m-0">
            <small>{{item.price | currency:'USD':'$':'1.2-4'}}/{{item.uom}} - {{item.amount |
              currency:'USD':'$':'1.2-2'}}
            </small>
          </mat-panel-description>
          <span class="pr-2">
            <span *ngIf="panelState.value === 'true'">
              <i class="fas fa-angle-down fa-2x"></i>
            </span>
            <span *ngIf="panelState.value === 'false'">
              <i class="fas fa-angle-right fa-2x"></i>
            </span>
          </span>
        </mat-expansion-panel-header>
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>{{item.name}}</mat-card-title>
            <mat-card-subtitle>
              Quantity: {{item.itemBalance.OnHandQuantity}}
              <br> Selling Unit of Measure: {{item.uom}}
              <br> Prepaid Unit: {{item.price}}
              <br> Amount: {{item.amount | currency:'USD':'$':'1.2-2'}}
            </mat-card-subtitle>
          </mat-card-header>
          <!-- <div id="itemUpdateButtonRow" class="text-right"> -->
          <div align="center">
            <button mat-button color="accent" class="ta-addeditem-edit magin_5 btn btn-warning text-white"
              (click)="editItem(item)">Edit</button>
            <button mat-button color="warn" class="ta-addeditem-delete btn btn-danger text-white"
              (click)="deleteItem(item)">Delete</button>

          </div>
        </mat-card>
      </mat-expansion-panel>
    </div>

    <mat-expansion-panel class="text-center" [expanded]="step === 5" (opened)="setStep(5)" [disabled]="isSummaryDisable"
      hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Summary
        </mat-panel-title>
        <mat-panel-description>
          <small> Summary </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-shipping-fast fa-2x"></i>
        </span>
      </mat-expansion-panel-header>


      <!-- <mat-form-field  floatLabel="never" style="display:none;">
        <input matInput [matDatepicker]="defaultStartDatePlaceHolder" [formControl]="defaultStartDate">
        <input matInput [matDatepicker]="defaultEndDatePlaceHolder" [formControl]="defaultEndDate">
      </mat-form-field> -->

      <!-- <mat-form-field appearance="fill" class="max-width-150">
        <mat-label>Start Date</mat-label>
        <input class="ta-summary-startingdate" [min]="minDate" matInput [matDatepicker]="startingDate"
          placeholder="Starting Date" (dateChange)="validateDates()" [(ngModel)]="bookingRequest.startDate"
          data-hj-whitelist>
        <mat-datepicker-toggle matSuffix [for]="startingDate"></mat-datepicker-toggle>
        <mat-datepicker #startingDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="max-width-150">
        <mat-label>End Date</mat-label>
        <input class="ta-summary-endingdate" [min]="bookingRequest.startDate" matInput [matDatepicker]="endingDate"
          placeholder="Ending Date" (dateChange)="validateDates()" [(ngModel)]="bookingRequest.endDate "
          data-hj-whitelist>
        <mat-datepicker-toggle matSuffix [for]="endingDate"></mat-datepicker-toggle>
        <mat-datepicker #endingDate></mat-datepicker>
      </mat-form-field> -->

      <mat-table class="table table-sm" #table [dataSource]="dataSource">

        <!-- <ng-container matColumnDef="categoryType">
          <mat-header-cell *matHeaderCellDef class="text-left"> Type </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.categoryType?item.categoryType:'Loading..'}}</small>
          </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="location">
          <mat-header-cell *matHeaderCellDef class="text-left"> Location </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.itemBalance.Location}}</small>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <mat-header-cell *matHeaderCellDef class="text-left"> Quantity </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.itemBalance.OnHandQuantity}}</small>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="text-left"> Name </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.name}}</small>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="prepaidAmount">
          <mat-header-cell *matHeaderCellDef class="text-right"> Amount </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-right">
            <small> {{item.amount | currency}}</small>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef class="text-left"> Start Date </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">{{item.startDate | date:'MM/dd/yy'}}
            <!-- <input class="ta-summary-startingdate" style="width: 80px;" [min]="item.minDate" matInput [matDatepicker]="startingDate"
          placeholder="Starting Date" (dateChange)="validateDates()" [(ngModel)]="item.startDate"
          data-hj-whitelist>
        <mat-datepicker-toggle matSuffix [for]="startingDate"></mat-datepicker-toggle>
        <mat-datepicker #startingDate></mat-datepicker> -->
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <mat-header-cell *matHeaderCellDef class="text-left"> End Date </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">{{item.endDate | date:'MM/dd/yy'}}
            <!-- <input style="width: 80px;" class="ta-summary-endingdate" [min]="item.startDate" matInput [matDatepicker]="endingdate"
          placeholder="Ending Date" (dateChange)="validateDates()" [(ngModel)]="item.endDate"
          data-hj-whitelist>
        <mat-datepicker-toggle matSuffix [for]="endingdate"></mat-datepicker-toggle>
        <mat-datepicker #endingdate></mat-datepicker> -->
          </mat-cell>
        </ng-container>

        <mat-header-row scope="row" style="padding:0px;min-height:20px;" *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row scope="row" style="padding:0px;min-height:20px;" *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>



      <mat-list align="left">
        <mat-list-item>
          <strong>Commitment Summary</strong>
          <br>
        </mat-list-item>
        <mat-list-item>
          <h6>
            <strong>{{totalItemsCount}}</strong>&nbsp;
            <small>product(s) selected for a total of </small>&nbsp;
            <strong class="text-success">
              {{bookingRequest.totalBookingAmount | currency}}
            </strong>
          </h6>
        </mat-list-item>
      </mat-list>


      <div align="center" [hidden]="(isBookEnabled || isPrepayEnabled) && (totalItemsCount > 0)">
        <!-- <button mat-button [ngClass]="'text-white btn btn-'+globals.colorTheme" (click)="PostBooking()">Finish</button> -->
        <button *ngIf="isQuoteUpdate" [disabled]="!isBookAllow" mat-button
          [ngClass]="'ta-convertqoute-next magin_5 text-white btn btn-'+globals.colorTheme"
          (click)="quote()">Next</button>
        <!-- <button *ngIf="isProUser && selectedFarmAndField != 'Not Selected.' && !isFromQuote" mat-button
        class="mat-stroked-button-WhiteBackground-GreenText ta-customer-openbooking magin_5 color_green"
        (click)="showSplitDetails()">Split Details</button> -->
        <span *ngIf="!isQuoteUpdate">
          <button *ngIf="!isQuoteBooking && !HideQuoteButton" [disabled]="!isBookAllow" mat-button
            [ngClass]="'ta-summary-quote magin_5 text-white btn btn-'+globals.colorTheme"
            (click)="quote()">{{QuoteButtonName}}</button>
          <button *ngIf="!HideBookingButton" [disabled]="!isBookAllow" mat-button
            [ngClass]="'ta-summary-book magin_5 text-white btn btn-'+globals.colorTheme"
            (click)="book()">{{BookingButtonName}}</button>
          <button *ngIf="!HidePrepayButton" [disabled]="!isPrepayAllow" mat-button
            [ngClass]="'ta-summary-prepay text-white btn btn-'+globals.colorTheme"
            (click)="prepay()">{{PrepayButtonName}}</button>
        </span>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="text-center" [expanded]="step === 6" (opened)="setStep(6)"
      *ngIf="isBookEnabled &&(totalItemsCount > 0)" hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{BookingButtonName}}
        </mat-panel-title>
        <mat-panel-description>
          <small> {{BookingButtonName}} </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-book fa-2x"></i>
        </span>
      </mat-expansion-panel-header>
      <app-book [quoteSignature]="signature" [qoutebookRemarks]="remarks"
        [bookingProgramDropdownItems]="bookingProgramDropdownItems" [showFarmAndFields]="showFarmAndFields && selectedFarmAndField !== 'Not Selected' && selectedFarmAndField !== 'Not Selected.'"
        [bookingProgramDropdownStatus]="bookingProgramDropdownStatus" [remarksCommenLimit]="getRemarksLimit('Book')"
        [bookingProgramDropdownRequired]="bookingProgramDropdownRequired" (confirmBook)="PostBooking($event)"
        (confirmSplitBook)="SplitPostBookingComplete($event)" (cancelBook)="receiveCancelBook()"
        [PendingSignatureRequiredStatus]="BookingSignatureRequiredStatus">
      </app-book>
    </mat-expansion-panel>

    <mat-expansion-panel formcontrolname class="text-center" [expanded]="step === 7"
      (opened)="setStep(7); updatePrepayCheckAmount();" *ngIf="isPrepayEnabled &&(totalItemsCount > 0)"
      hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{PrepayButtonName}}
        </mat-panel-title>
        <mat-panel-description>
          <small> {{PrepayButtonName}} </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-book fa-2x"></i>
        </span>
      </mat-expansion-panel-header>
      <app-prepay [quoteSignature]="signature" [qouteprepayRemarks]="remarks" [showFarmAndFields]="showFarmAndFields && selectedFarmAndField !== 'Not Selected' && selectedFarmAndField !== 'Not Selected.'"
        [prepayRemarks]="bookingRequest.bookingPrepay" [remarksCommenLimit]="getRemarksLimit('Prepay')"
        (confirmPrepay)="PostBooking($event)" (confirmSplitPrepay)="SplitPostBookingComplete($event)"
        (cancelPrepay)="receiveCancelPrepay() " [PendingSignatureRequiredStatus]="BookingSignatureRequiredStatus">
      </app-prepay>
    </mat-expansion-panel>

    <mat-expansion-panel class="text-center" [expanded]="step === 8" (opened)="setStep(8)"
      *ngIf="isQuoteEnabled &&(totalItemsCount > 0)" hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{QuoteButtonName}}
        </mat-panel-title>
        <mat-panel-description>
          <small> {{QuoteButtonName}} </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-money-check-alt fa-2x"></i>
        </span>
      </mat-expansion-panel-header>
      <app-quote [signature]="signature" [qouteRemarks]="remarks" [isAlert]="isAlert"
        [showFarmAndFields]="showFarmAndFields && selectedFarmAndField !== 'Not Selected' && selectedFarmAndField !== 'Not Selected.'" (confirmQuote)="PostBooking($event)"
        (confirmSplitQuote)="SplitPostBookingComplete($event)" (cancelQuote)="receiveCancelQuote()"
        [PendingSignatureRequiredStatus]="BookingSignatureRequiredStatus">
      </app-quote>
    </mat-expansion-panel>

  </mat-accordion>
</div>

<div (window:resize)="onResize($event)"></div>